/**
 * O relatorio para a diretoria.
 *
 * Uma pagina, um seletor de periodo, e CSS de impressao. Sem gerador de PDF:
 * `jsPDF` mais `html2canvas` sao ~400 kB e produzem saida pior que a impressao
 * do proprio navegador.
 */
export const nav = {
    permissao: 'deck.panorama:ver',
    section: 'Gestao',
    title: 'Panorama',
    icon: 'leaderboard',
    route: '/panorama',
    sequence: 25,
};

export default [
    {
        path: '/panorama',
        name: 'panorama',
        component: () => import('./pages/PanoramaPage.vue'),
        meta: { requiresAuth: true, permissao: 'deck.panorama:ver' },
    },
];
